export class Schedule {
    public id: number;
    public date: Date;
    public date1: string;
    public customerId: number;
    public identification: string;
    public company:string;
    public name: string;
    public email: string;
    public phone: string;
    public phoneMobile: string;
    public address: string;
    public provinciaId: number;
    public departmentId: number;
    public cityId: number;
    public neighborhood: string;
    public datePickup: Date;
    public datePickup1: String;
    public workSheduleId: number;
    public imei:string;
    public quantity: number;
    public observation: string;
    public nroTicket: string;
    public accountBilling: string;
    public filePdf: string;
    public process: number;
    public acceptP: boolean;
    public acceptE: boolean;
    public city: string;
    public customer: string;
    public department: string;
    public workShedule: string;
    public contactMethod: string;
    public reference: string;
    public referenceEq: string;
    public sourceModel: string;
    public sourceAccesories: string;
    public controlId: number;
    public EquipoId: number;

    constructor() {}
}